/*
 * @Author: Gang Jiang 
 * @Date: 2024-09-14 14:59:45 
 * @Last Modified by: Gang Jiang
 * @Last Modified time: 2025-02-19 11:44:13
 * Copy from web_h5_nuxt
 */
import axios from "axios";
import { message } from 'ant-design-vue';
import { getAcceptLanguageHeader } from '~/i18n'
// 创建实例
const service = axios.create({
  timeout: 30000, // 默认10秒超时
})

// 暂时使用测试环境
// let devPrefix = 'https://api.st1.artemisads.com';
let devPrefix = '';
let prefix = '';
if (location.origin.indexOf('aads') !== -1) {
  prefix = process.env.NODE_ENV === 'production' ? location.origin.replace('aads', 'apiaads') : devPrefix;
} else if (location.origin.indexOf('partnerize') !== -1) {
  prefix = process.env.NODE_ENV === 'production' ? location.origin.replace('partnerize', /\.[i|a]t\d/.test(location.host) ? 'apiaads' : 'api') : devPrefix;
} else {
  prefix = process.env.NODE_ENV === 'production' ? location.origin.replace('www', 'api') : devPrefix;
}

/**
 * 添加请求拦截器
 */
service.interceptors.request.use(
  config => {
    if(config.isV2) {
      config.url = prefix + '/api/artemisads/v2/' + config.url;
    }else{
    // 可以在请求时通过config.timeout设置超时时间
    if (config.url.indexOf('/api/storage') === -1) {
      config.url = prefix + '/api/artemisads/v1/' + config.url;
    }
  }

    const localStoragePrefix = location.hostname;
    const userToken = localStorage.getItem(`${localStoragePrefix}_userToken`);
    config.headers['Accept-Language'] = getAcceptLanguageHeader();
    if (config.url.match('/product/export')) {
      config.headers['responseType'] = 'blob';
    }
    if (config.url.match('/seller/switch-country')) {
      config.timeout = 30000; // 特定接口使用60秒超时
    }
    if (userToken) {
      config.headers['x-aa-authorization'] = `Bearer ${userToken}`;
    }
    return config;
  },
  error => {
    //请求错误时做些事
    return Promise.reject(error);
  }
);
service.interceptors.response.use(
  response => {
    let code = response.data.code

    if (code == 3006 || code == 3007 || code == 3008 || code == 3009 || code == 3010 || code==3001) {
      localStorage.clear();
      location.href = `${location.origin}/sign-in`;
    } else if (code == 2110) { // 子账号被禁用
      if (location.pathname !== '/sign-in') { // 当前页面不是登录页面
        if (!localStorage.getItem('accountDisabled')) { // 一个页面可能有多次请求, 避免重复设置
          localStorage.clear()
          localStorage.setItem('accountDisabled', response.data.error || 'Your account is inactive. Please contact your administrator.')
          location.href = `${location.origin}/sign-in`;
        }
      }
    }
  
    // console.log(response.data,'response.data');
    if(!response.data.success && response.data.code == 9999){
      message.error(response.data.error)
      return Promise.reject(response.data)
    }
    return response;
  }
);

export default service;
